import styled from 'styled-components/macro';
import { Helmet } from 'react-helmet-async';
import { Route, Switch, Redirect, useHistory } from 'react-router';
import { LoanList } from 'app/pages/LoanList/Loadable';
import { Header } from 'app/pages/MainLayout/components/Header';
import { NewLoan } from 'app/pages/NewLoan/Loadable';
import { ManageLoan } from 'app/pages/ManageLoan/Loadable';
import { WithConnection } from 'app/pages/ConnectWallet/WithConnection';
import { LoanDetail } from 'app/pages/LoanDetail/Loadable';
import { useEffect } from 'react';
import { useSetRecoilState } from 'recoil';
import { transactionStatus } from 'store/transaction';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorFallback } from 'app/Errors';

export function MainLayout() {
  const history = useHistory();
  const setTransaction = useSetRecoilState(transactionStatus);

  useEffect(() => {
    setTransaction({
      loading: false,
      tx: null,
      error: null,
    });
  }, [history.location.pathname]);

  return (
    <>
      <Helmet>
        <title>Home</title>
      </Helmet>
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <div className="min-w-screen min-h-screen flex flex-col bg-body text-white">
          <div className="px-8 md:px-16 py-6">
            <Header />
          </div>
          <div className="flex-auto flex md:px-8 lg:px-16 pt-6">
            <div className="flex-auto p-8 bg-black bg-opacity-25 rounded-t-3xl">
              <WithConnection>
                <Switch>
                  <Route path="/" exact>
                    <Redirect to="/loan/list" />
                  </Route>
                  <Route exact path="/owner/:address" component={ManageLoan} />
                  <Route exact path="/loan/list" component={LoanList} />
                  <Route exact path="/loan/new/:ilk" component={NewLoan} />
                  <Route exact path="/:owner/:id" component={LoanDetail} />
                </Switch>
              </WithConnection>
            </div>
          </div>
        </div>
      </ErrorBoundary>
    </>
  );
}
